"use client";

import { ChakraProvider } from "@chakra-ui/react";
import {
  ColorModeProvider,
  type ColorModeProviderProps,
} from "@/shared/ui/color-mode";
import moveonSystem from "./theme";

export function MyChakraProvider(props: ColorModeProviderProps) {
  return (
    <ColorModeProvider {...props}>
      <ChakraProvider value={moveonSystem}>{props.children}</ChakraProvider>
    </ColorModeProvider>
  );
}
